import { UserInfo } from '@app/modules/core/interfaces/user';

import { createAction, props } from '@ngrx/store';
import { StatsigExperimentsConfig } from '@statsig/statsig.entities';

export const fetchStatsigExperiments = createAction('[Experiments] Fetch Experiments',
  props<{ userInfo: UserInfo }>());

export const fetchStatsigExperimentsAsAnonymousUser = createAction('[Experiments] Fetch Experiments as anonymous user',
  props<{ userId: string }>());

export const fetchStatsigExperimentsSuccess = createAction('[Experiments] Fetch Experiments Success',
  props<{ experiments: StatsigExperimentsConfig[] }>());
